import {API} from 'aws-amplify';

export const read = async () => API.get('eventmanagerAdminApi', '/groups', {});

export const readOne = async (id) => API.get('eventmanagerAdminApi', `/groups/${id}`, {});

export const create = async (group) => API.put('eventmanagerAdminApi', `/groups`, {body: group});

export const update = async (group) => API.post('eventmanagerAdminApi', `/groups`, {body: group});

export const del = async (id) => API.del('eventmanagerAdminApi', `/groups/${id}`, {});
